/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesMembershipProductType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type WebApiModelsEnumerationTypesMembershipProductType = typeof WebApiModelsEnumerationTypesMembershipProductType[keyof typeof WebApiModelsEnumerationTypesMembershipProductType];


export function WebApiModelsEnumerationTypesMembershipProductTypeFromJSON(json: any): WebApiModelsEnumerationTypesMembershipProductType {
    return WebApiModelsEnumerationTypesMembershipProductTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesMembershipProductTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesMembershipProductType {
    return json as WebApiModelsEnumerationTypesMembershipProductType;
}

export function WebApiModelsEnumerationTypesMembershipProductTypeToJSON(value?: WebApiModelsEnumerationTypesMembershipProductType | null): any {
    return value as any;
}

